import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  sellerProducts: null,
  singleProductDetails: null,
  singleProductImages: null,
  // sellerProductImage: null,
  buyerProducts: null,
  addProductRes: null,
  // productPreview: null,
  productDetails: null,
  newProducts: null,
  bestSellerProduct: null,
  moreProductFromSeller: null,
  productImage: {},
  deletedImages: [],
  uploadedImages: [],
  productImageAdvertId:{},
  singleProductFeedbacks: [],
  singleProductFeedbackSummary: null,
  error: null,
  loading: false,
};

// Add Product
const addProductStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const addProductSuccess = (state: any, action: any) => {
  return updateObject(state, {
    addProductRes: action.addProductRes,
    singleProductDetails: null,
    singleProductImages: null,
    error: null,
    loading: false,
  });
};

const addProductFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    addProductRes: null,
  });
};

// Preview Details
const addProductDetails = (state: any, action: any) => {
  return updateObject(state, {
    productDetails: action.productDetails,
    error: null,
    loading: false,
  });
};

// Preview Product
const addProductPreviewStart = (state: any) => {
  return updateObject(state, {
    singleProductDetails: null,
    error: null,
    loading: true,
  });
};

const addProductPreview = (state: any, action: any) => {
  return updateObject(state, {
    singleProductDetails: action.productPreview,
    error: null,
    loading: false,
  });
};

const addProductPreviewImagesStart = (state: any) => {
  return updateObject(state, {
    singleProductImages: null,
    error: null,
    loading: false,
  });
};

export const addProductPreviewImages = (state: any, action: any) => {
  return updateObject(state, {
    singleProductImages: action.productPreviewImages,
    error: null,
    loading: false,
  });
};

// Get Seller Products
const getSellerProductStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getSellerProductSuccess = (state: any, action: any) => {
  return updateObject(state, {
    sellerProducts: action.sellerProducts,
    error: null,
    loading: false,
  });
};

const getSellerProductFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    sellerProducts: null,
  });
};

// Get Seller Products Details By ID
const getProductDetailsStart = (state: any, action: any) => {
  return updateObject(state, {
    error: null,
    loading: true,
    singleProductDetails: null,
    singleProductFeedbackSummary: null,
    singleProductFeedbacks: [],
  });
};

const getProductDetailsSuccess = (state: any, action: any) => {
  return updateObject(state, {
    singleProductDetails: action.singleProductDetails,
    error: null,
    loading: false,
  });
};

const getProductDetailsFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    singleProductDetails: null,
  });
};

// Get Seller Products Image
const getSingleProductImagesStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getSingleProductImagesSuccess = (state: any, action: any) => {
  if (action.singleProductImages) {
    return updateObject(state, {
      singleProductImages: {
        ...state.singleProductImages,
        [action.singleProductImages?.advertId]:
          action.singleProductImages?.data,
      },
      error: null,
      loading: false,
    });
  } else {
    return updateObject(state, {
      singleProductImages: null,
      error: null,
      loading: false,
    });
  }
};

const getSingleProductImagesFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    singleProductImages: null,
  });
};

// Get Buyer Products
const getBuyerProductStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getBuyerProductSuccess = (state: any, action: any) => {
  return updateObject(state, {
    buyerProducts: action.buyerProducts,
    error: null,
    loading: false,
  });
};

const getBuyerProductFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    buyerProducts: null,
  });
};

// Get Products Image
const getProductImageStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getProductImageSuccess = (state: any, action: any) => {
  return updateObject(state, {
    productImage: {
      ...state.productImage,
      // [action.productImage.advertId]: action.productImage.data,

      [action.productImage.advertId]: {
        ...(state.productImage[action.productImage.advertId] && state.productImage[action.productImage.advertId]),
        ...(action.isLr ? {lr: action.productImage.data} : {hr: action.productImage.data}),
      },
    },
    error: null,
    loading: false,
  });
};

const getProductImageFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    // productImage: {},
  });
};

// New Products
export const getNewProductsStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

export const getNewProductsSuccess = (state: any, action: any) => {
  return updateObject(state, {
    newProducts: action.newProducts,
    error: null,
    loading: false,
  });
};

export const getNewProductsFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    newProducts: null,
  });
};

// Get BestSeller Products
export const getBestSellerProductsStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

export const getBestSellerProductsSuccess = (state: any, action: any) => {
  return updateObject(state, {
    bestSellerProduct: action.bestSellerProduct,
    error: null,
    loading: false,
  });
};

export const getBestSellerProductsFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    bestSellerProduct: null,
  });
};

// Delete Product
const deleteProductStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const deleteProductSuccess = (state: any, action: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const deleteProductFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Edit Product
const editProductStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const editProductSuccess = (state: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const editProductFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// More Products from seller
const getMoreProductFromSellerStart = (state: any,) => {
  return updateObject(state, { error: null, loading: true});
};

const getMoreProductFromSellerSuccess = (state: any, action: any) => {
  return updateObject(state, {
    loading: false,
    moreProductFromSeller: action.products,
  });
};

const getMoreProductFromSellerFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    moreProductFromSeller: null,
  });
};


// control deleted Images 
const addToDeletedImages = (state: any, action: any) => {
  return updateObject(state, {
    deletedImages: [...state.deletedImages, action.data],
  });
};

const clearDeletedImages = (state: any) => {
  return updateObject(state, {
    deletedImages: [],
  });
};

// control uploaded Images 
const updateUploadedImages = (state: any, action: any) => {
  return updateObject(state, {
    uploadedImages: action.data,
  });
};

const clearUploadedImages = (state: any) => {
  return updateObject(state, {
    uploadedImages: [],
  });
};

// Get advert Images using Advert Id
const getImageFromAdvertIdStart = (state: any) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const getImageFromAdvertIdSuccess = (state: any, action: any) => {
  return updateObject(state, {
    productImageAdvertId: {
      ...state.productImageAdvertId, 
      [action.productImageAdvertId?.advertId]:
      action.productImageAdvertId?.data,
    },
    error: null,
    loading: false,
  });
};

const getImageFromAdvertIdFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action?.error,
    loading: false,
  });
};

// Get Product feedbacks By Advert ID
const getProductFeedbacksStart = (state: any) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const getProductFeedbacksSuccess = (state: any, action: any) => {
  return updateObject(state, {
    singleProductFeedbacks: action.productFeedbacks?.items,
    error: null,
    loading: false,
  });
};

const getProductFeedbacksFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action?.error,
    loading: false,
  });
};

// Get Product feedback Summary By Advert ID
const getProductFeedbackSummaryStart = (state: any) => {
  return updateObject(state, {
    singleProductFeedbackSummary: null,
    error: null,
    loading: true,
  });
};

const getProductFeedbackSummarySuccess = (state: any, action: any) => {
  return updateObject(state, {
    singleProductFeedbackSummary: action.ProductFeedbackSummary,
    error: null,
    loading: false,
  });
};

const getProductFeedbackSummaryFailed = (state: any, action: any) => {
  return updateObject(state, {
    singleProductFeedbackSummary: null,
    error: action?.error,
    loading: false,
  });
};

// Add Review
const addReviewStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const addReviewSuccess = (state: any) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const addReviewFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const productReducer = (state = initialState, action: any) => {
  switch (action.type) {
    // Add product
    case actionTypes.ADD_PRODUCT_START:
      return addProductStart(state, action);
    case actionTypes.ADD_PRODUCT_SUCCESS:
      return addProductSuccess(state, action);
    case actionTypes.ADD_PRODUCT_FAIL:
      return addProductFailed(state, action);

    // Product Preview
    case actionTypes.ADD_PRODUCT_DETAILS:
      return addProductDetails(state, action);

    // Product Preview
    case actionTypes.ADD_PRODUCT_PREVIEW_START:
      return addProductPreviewStart(state);
    case actionTypes.ADD_PRODUCT_PREVIEW:
      return addProductPreview(state, action);
    case actionTypes.ADD_PRODUCT_PREVIEW_IMAGES_START:
      return addProductPreviewImagesStart(state);
    case actionTypes.ADD_PRODUCT_PREVIEW_IMAGES:
      return addProductPreviewImages(state, action);

    // Get Seller Products
    case actionTypes.GET_SELLER_PRODUCT_START:
      return getSellerProductStart(state, action);
    case actionTypes.GET_SELLER_PRODUCT_SUCCESS:
      return getSellerProductSuccess(state, action);
    case actionTypes.GET_SELLER_PRODUCT_FAIL:
      return getSellerProductFailed(state, action);

    //Get Seller Products Details By ID
    case actionTypes.GET_PRODUCT_DETAILS_START:
      return getProductDetailsStart(state, action);
    case actionTypes.GET_PRODUCT_DETAILS_SUCCESS:
      return getProductDetailsSuccess(state, action);
    case actionTypes.GET_PRODUCT_DETAILS_FAIL:
      return getProductDetailsFailed(state, action);

    //Get Seller Product Images
    case actionTypes.GET_SINGLE_PRODUCT_IMAGES_START:
      return getSingleProductImagesStart(state, action);
    case actionTypes.GET_SINGLE_PRODUCT_IMAGES_SUCCESS:
      return getSingleProductImagesSuccess(state, action);
    case actionTypes.GET_SINGLE_PRODUCT_IMAGES_FAIL:
      return getSingleProductImagesFailed(state, action);

    //Get Buyer Products
    case actionTypes.GET_BUYER_PRODUCT_START:
      return getBuyerProductStart(state, action);
    case actionTypes.GET_BUYER_PRODUCT_SUCCESS:
      return getBuyerProductSuccess(state, action);
    case actionTypes.GET_BUYER_PRODUCT_FAIL:
      return getBuyerProductFailed(state, action);

    //Get Product Images
    case actionTypes.GET_PRODUCT_IMAGE_START:
      return getProductImageStart(state, action);
    case actionTypes.GET_PRODUCT_IMAGE_SUCCESS:
      return getProductImageSuccess(state, action);
    case actionTypes.GET_PRODUCT_IMAGE_FAIL:
      return getProductImageFailed(state, action);

    // Get new Products
    case actionTypes.GET_NEW_PRODUCT_START:
      return getNewProductsStart(state);
    case actionTypes.GET_NEW_PRODUCT_SUCCESS:
      return getNewProductsSuccess(state, action);
    case actionTypes.GET_NEW_PRODUCT_FAIL:
      return getNewProductsFailed(state, action);

    // Get bestSeller Products
    case actionTypes.GET_BEST_SELLER_PRODUCT_START:
      return getBestSellerProductsStart(state);
    case actionTypes.GET_BEST_SELLER_PRODUCT_SUCCESS:
      return getBestSellerProductsSuccess(state, action);
    case actionTypes.GET_BEST_SELLER_PRODUCT_FAIL:
      return getBestSellerProductsFailed(state, action);

    // Delete Products
    case actionTypes.DELETE_PRODUCT_START:
      return deleteProductStart(state, action);
    case actionTypes.DELETE_PRODUCT_SUCCESS:
      return deleteProductSuccess(state, action);
    case actionTypes.DELETE_PRODUCT_FAIL:
      return deleteProductFailed(state, action);

    // Edit Products
    case actionTypes.EDIT_PRODUCT_START:
      return editProductStart(state);
    case actionTypes.EDIT_PRODUCT_SUCCESS:
      return editProductSuccess(state);
    case actionTypes.EDIT_PRODUCT_FAIL:
      return editProductFailed(state, action);

    // More Products from seller
    case actionTypes.GET_MORE_PRODUCT_FROM_SELLER_START:
      return getMoreProductFromSellerStart(state);
    case actionTypes.GET_MORE_PRODUCT_FROM_SELLER_SUCCESS:
      return getMoreProductFromSellerSuccess(state, action);
    case actionTypes.GET_MORE_PRODUCT_FROM_SELLER_FAIL:
      return getMoreProductFromSellerFailed(state, action);

    // Deleted Images
    case actionTypes.ADD_TO_DELETED_IMAGES:
      return addToDeletedImages(state, action);
    case actionTypes.CLEAR_DELETED_IMAGES:
      return clearDeletedImages(state);

    // Uploaded Images
    case actionTypes.ADD_TO_UPLOADED_IMAGES:
      return updateUploadedImages(state, action);
    case actionTypes.CLEAR_UPLOADED_IMAGES:
      return clearUploadedImages(state);

// Get advert Images using Advert Id
    case actionTypes.GET_IMAGE_FROM_ADVERTID_START:
      return getImageFromAdvertIdStart(state);
    case actionTypes.GET_IMAGE_FROM_ADVERTID_SUCCESS:
      return getImageFromAdvertIdSuccess(state, action);
    case actionTypes.GET_IMAGE_FROM_ADVERTID_FAIL:
      return getImageFromAdvertIdFailed(state, action);

  // Get Product feedbacks By Advert ID
  case actionTypes.GET_PRODUCT_FEEDBACKS_START:
    return getProductFeedbacksStart(state);
  case actionTypes.GET_PRODUCT_FEEDBACKS_SUCCESS:
    return getProductFeedbacksSuccess(state, action);
  case actionTypes.GET_PRODUCT_FEEDBACKS_FAIL:
    return getProductFeedbacksFailed(state, action);

  // Get Product feedback Summary By Advert ID
  case actionTypes.GET_PRODUCT_FEEDBACK_SUMMARY_START:
    return getProductFeedbackSummaryStart(state);
  case actionTypes.GET_PRODUCT_FEEDBACK_SUMMARY_SUCCESS:
    return getProductFeedbackSummarySuccess(state, action);
  case actionTypes.GET_PRODUCT_FEEDBACK_SUMMARY_FAIL:
    return getProductFeedbackSummaryFailed(state, action);

  // Add Review
  case actionTypes.ADD_REVIEW_START:
    return addReviewStart(state);
  case actionTypes.ADD_REVIEW_SUCCESS:
    return addReviewSuccess(state);
  case actionTypes.ADD_REVIEW_FAIL:
    return addReviewFailed(state, action);

    default:
      return state;
  }
};

export default productReducer;
